// extracted by mini-css-extract-plugin
export default {"statusBadge":"CandidateStatusBadge_statusBadge__B9Eha"};